export class SidekickCustomer {
  clonable: boolean;
  id: string;
  legacyForms: boolean | null;
  logoURL: string | null;
  name: string;
  slug: string;
  statusID: number;
  useConversations: boolean;
}
